export const SET_COURSES = "SET_COURSES";
export const SET_COURSE = "SET_COURSE";
export const FETCH_QUIZ = "FETCH_QUIZ";
export const UPDATE_QUIZ_ID = "UPDATE_QUIZ_ID";
export const SET_SCORE = "SET_SCORE";
export const SET_ANSWER_BY_DRIVER = "SET_ANSWER_BY_DRIVER";
export const SET_DATA_VIDEO = "SET_DATA_VIDEO";
export const SET_DATA_LESSON = "SET_DATA_LESSON";
export const SET_DATA_QUIZ = "SET_DATA_QUIZ";

// ONBOARDING DRIVER

export const SET_DRIVER_ID = "SET_DRIVER_ID";
export const SET_DATA_LOGIN = "SET_DATA_LOGIN";
export const SET_AUTHENTICATE_TYPE = "SET_AUTHENTICATE_TYPE";
export const SET_DATA_ACTIVATE = "SET_DATA_ACTIVATE";
export const SET_DATA_PROFILE = "SET_DATA_PROFILE";

export const SET_DATA_LOCATION = "SET_DATA_LOCATION";

// export const SET_SUCCESS_STEP = "SET_SUCCESS_STEP";
// export const SET_TOKEN = "SET_TOKEN";

// export const SET_STATUS_STEP = "SET_STATUS_STEP";

export const SET_SUPPLIER_TOKEN = "SET_SUPPLIER_TOKEN";
export const SET_SUPPLIER_PROFILE = "SET_SUPPLIER_PROFILE";
export const SET_FIREBASE_CONFIRMATION = "SET_FIREBASE_CONFIRMATION";

export const SET_GENERAL_PROFILE = "SET_GENERAL_PROFILE";
export const SET_IDENTITY_PROFILE = "SET_IDENTITY_PROFILE";
export const SET_ADDRESS_PROFILE = "SET_ADDRESS_PROFILE";
export const SET_VEHICLE_PROFILE = "SET_VEHICLE_PROFILE";
export const SET_RELATIVE_PROFILE = "SET_RELATIVE_PROFILE";

export const SET_CITY_LIST = "SET_CITY_LIST";

export const GET_LIST_COVID_TEST = 'GET_LIST_COVID_TEST'
export const CREATE_COVID_TEST = 'CREATE_COVID_TEST'
export const GET_COVID_TEST_ITEM = 'GET_COVID_TEST_ITEM'